import { render, staticRenderFns } from "./reportVendite.vue?vue&type=template&id=52c2f1d1&"
import script from "./reportVendite.vue.ts?vue&type=script&lang=ts&"
export * from "./reportVendite.vue.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports